module.exports = {"publishedEvents":"Published Events","pastEvents":"Past Events","unpublishedEvents":"Unpublished Events","currentEvents":"Current Events","limit":"Number of events","page":"Page","refresh":"Refresh"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/EventCategory/locales/en.json
// module id = 1139
// module chunks = 0